import {useEffect, useState} from "react";
import {BreadCrumbs} from "../../../components/open/pages";
import {GregorianToPersian} from "../../../components/techaran/date-convert";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {
    CheckIcon,
    ThinClassIcon,
    ThinEditIcon,
    ThinPrintIcon,
    ThinTimeIcon,
    ThinTrashIcon,
    TomansIcon
} from "../../../components/icons/material-icons";
import {SelectClassModal} from "../classes/select-class-modal";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {Link} from "react-router-dom";
import {AddEditTuitionReminderModal} from "../students/add-edit-tuition-reminder";
import {RemoveModal} from "../../../components/template/remove-modal";
import {ShowSnackbar} from "../../../components/template/snackbar";

export interface allReminderInterface {
    id: number,
    studentId: number,
    name: string,
    price: number,
    remindDate: string,
    isReminded: 0 | 1,
}

export const AdminsFinanceRemindersListScreen = () => {
    const [loaded, setLoaded] = useState(false);
    const [list, setList] = useState([] as allReminderInterface[]);
    const [classSelected, setClassSelected] = useState({
        id: 0,
        title: '',
    });
    const [classModal, setClassModal] = useState(false);
    const fetchList = (classId: number) => {
        setLoaded(false);
        ShowProgressLoading();
        PostJSON(
            Apis.server + "/core/admins/finance/reminders/list",
            {
                classId: classId.toString(),
            },
            true,
            (d: {
                result: string,
                reason: string | undefined,
                list: allReminderInterface[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setLoaded(true);
                setList(d.list === null ? [] : d.list);
            },
            () => {
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "یادآوری های شهریه | نهال";
        fetchList(0);
    }, []);
    const [removeReminder, setRemoveReminder] = useState({
        show: false,
        id: 0,
    });
    const doRemoveReminder = () => {
        const reminderId = removeReminder.id;
        const _class = {...classSelected};
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/students/tuition/reminders/remove',
            {id: reminderId.toString()},
            true,
            (d: {
                result: string,
                reason: string | undefined,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                fetchList(_class.id);
                ShowSnackbar('یادآوری موردنظر حذف شد.', 'باشه', 5000);
            },
            () => {
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    const [editReminder, setEditReminder] = useState({
        show: false,
        id: 0,
        date: '2000-01-01',
        price: 0,
        isReminded: false,
        studentId: 0,
    });
    return (
        <>
            <BreadCrumbs links={[
                {title: 'اتوماسیون', url: '/admins/'},
                {title: 'امور مالی', url: '/admins/finance'},
                {title: 'یادآوری‌های شهریه', url: '/admins/finance/reminders'},
            ]}/>
            {
                loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                        <div className="screen-card">
                            <div className="screen-card-header">
                                <b>یادآوری‌های شهریه</b>
                                <div className="d-inline-flex align-items-center" style={{gap: 10}}>
                                    <button onClick={() => {
                                        const _class = {...classSelected};
                                        window.open(`/print/admins/finance/reminders/${_class.id}`);
                                    }}>
                                        <ThinPrintIcon/>
                                        <span>پرینت</span>
                                    </button>
                                    <button onClick={() => setClassModal(true)}>
                                        <ThinClassIcon/>
                                        <span>{classSelected.id > 0 ? classSelected.title : 'همه کلاس‌ها'}</span>
                                    </button>
                                </div>
                            </div>
                            <table className="table open-table table-striped table-bordered table-hover">
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>دانش‌آموز</th>
                                    <th>مبلغ</th>
                                    <th>تاریخ یادآوری</th>
                                    <th>وضعیت</th>
                                    <th>امکانات</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    list.map((p, i) =>
                                        <tr key={"K39EsSrCnS2" + i}>
                                            <td>{StringDigitsConvertToPersian(i + 1)}</td>
                                            <td>
                                                <Link to={`/admins/students/view/${p.studentId}`}>
                                                    {p.name}
                                                </Link>
                                            </td>
                                            <td>
                                                <span>{CurrencyFormat(p.price)}<TomansIcon/></span>
                                            </td>
                                            <td>{StringDigitsConvertToPersian(GregorianToPersian(p.remindDate.split(' ')[0]).replaceAll('-', '/'))}</td>
                                            <td>
                                                {
                                                    p.isReminded === 1 ?
                                                        <em>
                                                            <CheckIcon/>
                                                            اعلام شده
                                                        </em> :
                                                        <em data-color={"red"}>
                                                            <ThinTimeIcon/>
                                                            در انتظار
                                                        </em>
                                                }
                                            </td>
                                            <td>
                                                <div style={{gap: 5}}
                                                     className="d-inline-flex align-items-center">
                                                    <button
                                                        onClick={() => setEditReminder({
                                                            show: true,
                                                            id: p.id,
                                                            price: p.price,
                                                            date: p.remindDate,
                                                            isReminded: p.isReminded === 1,
                                                            studentId: p.studentId,
                                                        })}
                                                        className="open-tooltip">
                                                        <ThinEditIcon/>
                                                        <i>ویرایش</i>
                                                    </button>
                                                    <button
                                                        onClick={() => setRemoveReminder({
                                                            id: p.id,
                                                            show: true,
                                                        })}
                                                        className="open-tooltip">
                                                        <ThinTrashIcon/>
                                                        <i>حذف</i>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                }
                                </tbody>
                            </table>
                        </div>
                    </div> : null
            }
            <SelectClassModal
                active={classModal}
                closeHandler={() => setClassModal(false)}
                onSelected={(id: number, title: string) => {
                    // ShowProgressLoading();
                    setClassSelected({
                        title: "کلاس " + title,
                        id: id,
                    });
                    window.scrollTo({top: 0, behavior: 'smooth'});
                    fetchList(id);
                }}
            />
            <AddEditTuitionReminderModal
                active={editReminder.show}
                remindDate={editReminder.date}
                price={editReminder.price}
                isReminded={editReminder.isReminded}
                isEdit={true}
                reminderId={editReminder.id}
                onDone={() => {
                    const c = {...classSelected};
                    ShowProgressLoading();
                    fetchList(c.id);
                }}
                closeHandler={() => setEditReminder(b => {
                    let x = {...b};
                    x.show = false;
                    return x;
                })}
                studentId={editReminder.studentId.toString()}
            />
            <RemoveModal
                active={removeReminder.show}
                closeHandler={() => setRemoveReminder(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                title={"حذف یادآوری"}
                desc={"آیا مطمئن هستید می‌خواهید این یادآوری حذف گردد؟"}
                onRemove={doRemoveReminder}
            />
        </>
    );
};